import { delegate } from "bobjoll/ts/library/dom";
import Share from 'Project/ts/partials/share';

delegate('button[data-network]', 'click', Share.url);